import {
  EMapService,
  IRegularInfrastructureData,
  ITAInfrastructureData,
  TTAInfrastructureType,
} from '../../../types/map';

export const findGeoObjectDatum = (
  geoObjectId: string,
  regularInfrastructureByYear: Map<number, IRegularInfrastructureData>,
  transportAccessibilityInfrastructureByType: Map<TTAInfrastructureType, ITAInfrastructureData>,
  mapService: EMapService | null,
) => {
  if (mapService === EMapService.TransportAccessibility) {
    return findTAGeoObjectDatum(geoObjectId, transportAccessibilityInfrastructureByType);
  }

  return findRegularGeoObjectDatum(geoObjectId, regularInfrastructureByYear);
};

function findRegularGeoObjectDatum(
  geoObjectId: string,
  regularInfrastructureByYear: Map<number, IRegularInfrastructureData>,
) {
  const yearInfrastructures = Array.from(regularInfrastructureByYear.values());

  for (const { geoObjectsData } of yearInfrastructures) {
    for (const datum of geoObjectsData) {
      if (datum.geoObject.options.id === geoObjectId) {
        return datum;
      }
    }
  }

  return null;
}

function findTAGeoObjectDatum(
  geoObjectId: string,
  transportAccessibilityInfrastructureByType: Map<TTAInfrastructureType, ITAInfrastructureData>,
) {
  const infrastructuresByTypes = Array.from(transportAccessibilityInfrastructureByType.values());

  for (const { geoObjectsData } of infrastructuresByTypes) {
    for (const datum of geoObjectsData) {
      if (datum.geoObject.options.id === geoObjectId) {
        return datum;
      }
    }
  }

  return null;
}
